import {apiGet, apiPost, apiPut, apiDelete, apiPatch} from '@/utils/request'

/**
 * 微信公众号授权接口
 *
 * @link http://yapi.acagrid.com/project/29/interface/api/1141
 * 
 * @param  {string} code [公众号网页授权code]
 * @return {[type]}    [description]
 *
 * @return Promise
 * 
 * @author Pandex
 */
export function wechatAuth(code, state) {
    return apiPost('/user/wechat_oauth', {code, state})
}

/**
 * 令牌刷新接口
 *
 * @link http://yapi.acagrid.com/project/29/interface/api/1143
 * 
 * @param  {string} refresh_token [用户刷新令牌]
 * @param  {string} openid [用户openid]
 * @return {[type]}    [description]
 *
 * @return Promise
 * 
 * @author Pandex
 */
export function refreshToken(refresh_token,openid) {
    return apiPost('/user/refresh_token', {refresh_token,openid})
}

/**
 * 获取用户信息接口 
 *
 * @link http://yapi.acagrid.com/project/29/interface/api/1145
 * 
 * @return {[type]}    [description]
 *
 * @return Promise
 * 
 * @author Pandex
 */
export function getUserInfo() {
  return apiGet('/user/info')
}

/**
 * 根据用户id获取用户信息 
 *
 * @link http://yapi.acagrid.com/project/29/interface/api/1145
 * 
 * @return int user_id 用户id
 *
 * @return Promise
 * 
 * @author Vince
 */
export function getUserBasicInfo(user_id,source) {
  return apiGet('/user/simple_info', {user_id,source})
}

/**
 * 获取家长信息接口
 *
 * @link http://yapi.acagrid.com/project/29/interface/api/1269
 *
 * @author vince
 */
export function getParentInfo() {
  return apiGet('/parents/info')
}

/**
 * 绑定手机接口
 *
 * @link http://yapi.acagrid.com/project/29/interface/api/1187
 * 
 * @param  {string} mobile [手机号码]
 * @param  {string} code [验证码]
 * @return {[type]}    [description]
 *
 * @return Promise
 * 
 * @author Pandex
 */
export function bindMobile(mobile,code) {
  return apiPut('/user/bind_mobile', {mobile,code})
}

/**
 * 验证手机接口
 *
 * @link http://yapi.acagrid.com/project/29/interface/api/4285
 * 
 * @param  {string} mobile [手机号码]
 * @param  {string} code [验证码]
 * @return {[type]}    [description]
 *
 * @return Promise
 * 
 * @author Pandex
 */
export function checkMobile(mobile,code) {
  return apiPost('/user/check_mobile', {mobile,code})
}

/**
 * 修改绑定手机接口
 *
 * @link http://yapi.acagrid.com/project/29/interface/api/4293
 * 
 * @param  {string} mobile [手机号码]
 * @param  {string} code [验证码]
 * @return {[type]}    [description]
 *
 * @return Promise
 * 
 * @author Pandex
 */
export function updateMobile(mobile,code) {
  return apiPut('/user/update_mobile', {mobile,code})
}

/**
 * 获取用户积分明细接口
 *
 * @link http://yapi.acagrid.com/project/29/interface/api/1249
 *
 * @author Pandex
 */
export function getUserRewardLists(page) {
  return apiGet('/user/reward_lists',{page})
}

/**
 * 绑定机器人接口
 *
 * @link http://yapi.acagrid.com/project/29/interface/api/1167
 * @param  {string} wid [机器人微信唯一标识]
 * @param  {string} user_wid [用户微信唯一标识]
 * @return {[type]}    [description]
 *
 * @author Pandex
 */
export function bindRobot(wid,user_wid) {
  return apiPost('/user/bind_robot',{wid,user_wid})
}

/**
 * 获取当前用户管理班级列表，及个班基础统计信息
 *
 * @link http://yapi.acagrid.com/project/29/interface/api/1291
 * 
 * @return Promise
 *
 * @author vince
 */
// export function getAdminClassList() {
//   return apiGet('/user/admin')
// }

/**
 * 获取当前用户邀请用户的列表
 *
 * @link http://yapi.acagrid.com/project/29/interface/api/1339
 * 
 * @return Promise
 */
export function getInvitedFriends() {
  return apiGet('/user/refer_lists')
}

/**
 * 活跃任务完成情况接口
 *
 * @link http://yapi.acagrid.com/project/29/interface/api/1337
 * 
 * @return Promise
 *
 * @author vince
 */
export function getActiveTaskData() {
  return apiGet('/user/rewards_active')
}
/**
 * 获取当前用户邀请家长的列表
 *
 * @link http://yapi.acagrid.com/project/29/interface/api/1642
 *
 * @param  {int} student_id [学生id]
 * 
 * @return Promise
 */
export function getInvitedParents(student_id) {
  return apiGet('/parents/invited', {student_id})
}
/**
 * 获取当前用户邀请家长的列表
 *
 * @link http://yapi.acagrid.com/project/29/interface/api/1650
 *
 * @param  {int} student_id [学生id]
 * 
 * @return Promise
 */
export function getStudentParentInviter(student_id, user_id) {
  return apiGet('/parents/inviter_info', {student_id, user_id})
}
/**
 * 兑换用户积分
 *
 * @link http://yapi.acagrid.com/project/29/interface/api/1361
 * 
 * @param  {int} money [兑换钱数]
 *
 * @return Promise
 * 
 * @author Pandex
 */
export function requestExchangeCredits(money) {
  return apiPost('/user/reward/exchange', {money})
}

/**
* 获取用户积分信息接口
*
* @link http://yapi.acagrid.com/project/29/interface/api/1367
*
* @author Pandex
*/
export function getUserCreditInfo() {
  return apiGet('/user/reward/info')
}

/**
* 获取用户是否请求添加机器人好友
*
* @author Pandex
*/
export function hasRequestedRobot() {
  return apiGet('/user/has_friend_request')
}

/**
* PC端获取二维码登录随机码
*
* @author Pandex
*/
export function getLoginQrcodeToken() {
  return apiGet('/user/qrcode_auth_token')
}

/**
* 获取公众号登录二维码
* @link http://yapi.acagrid.com/project/29/interface/api/2557
*
* @author Pandex
*/
export function getMPQrcodeToken(scene, token, source) {
  let param = {scene}
  if (token) {
    param.token = token
  }
  if (source) {
    param.source = source
  }
  return apiGet('/user/mp_auth_qrcode', param)
}

/**
* 获取公众号登录二维码
* @link http://yapi.acagrid.com/project/29/interface/api/3765
*
* @author Pandex
*/
export function getCertificatesMPQrcode(certificate_url) {
  return apiGet('/promote/instant_certificates/download_qrcode', {certificate_url})
}

/**
 * 轮询获取二维码登录状态接口
 *
 * @link http://yapi.acagrid.com/project/29/interface/api/2098
 * 
 * @param  {String} token [随机码]
 *
 * @return Promise
 * 
 * @author Pandex
 */
export function requestLoginTokenStatus(token) {
  return apiPost('/user/qrcode_auth_status', {token})
}

/**
 * 班主任任务完成状况接口
 *
 * @link http://yapi.acagrid.com/project/29/interface/api/2122
 *
 * @author Pandex
 */
export function getAdminTaskStatus() {
  return apiGet('/user/admin_task_status')
}

/**
 * 班主任任务完成状况接口
 *
 * @link http://yapi.acagrid.com/project/29/interface/api/2365
 *
 * @author Pandex
 */
export function getDoubleTaskStatus() {
  return apiGet('/promote/teacher/double_reward_tasks')
}

/**
 * 用户获取小助手二维码
 *
 * @link http://yapi.acagrid.com/project/29/interface/api/2187
 *
 * @author Pandex
 */
export function getAdminClassBotQrcode() {
  return apiGet('/user/clean_qrcode')
}
/**
 * 公众号未活跃用户获取激活二维码接口
 *
 * @link http://yapi.acagrid.com/project/29/interface/api/2957
 *
 * @author Pandex
 */
export function getUserActiveQrcode(url) {
  return apiGet('/user/mp_active_qrcode', {url})
}

/**
 * 更新用户设置接口
 *
 * @link http://yapi.acagrid.com/project/29/interface/api/3517
 *
 * @author Pandex
 */
export function updateUserSettings(setting_name, setting_value) {
  return apiPut('/user/settings', {setting_name, setting_value})
}

/**
 * 用户管理主页接口新
 *
 * @link http://yapi.acagrid.com/project/29/interface/api/4893
 * 
 * @return Promise
 *
 * @author Pandex
 */
 export function getAdminClassList() {
  return apiGet('/user/admin_home')
}

/**
 * 获取班级管理统计信息接口
 *
 * @link http://yapi.acagrid.com/project/29/interface/api/4901
 * 
 * @return Promise
 *
 * @author Pandex
 */
 export function getAdminClassStats(id) {
  return apiGet('/class/:id/admin_stats', {id})
}


/**
 * 更新公众号置顶状态
 *
 * @link https://app.apifox.com/project/2506732/apis/api-221675072
 * 
 * @return Promise
 *
 * @author Pandex
 */
export function updateWechatTopup(openid) {
  return apiPut('/user/wechat_top_up', {openid})
}






// 管理员命令

/**
 * 用户 - 申请班级管理员token接口
 *
 * @link http://yapi.acagrid.com/project/29/interface/api/1321
 * 
 * @return Promise
 *
 * @author vince
 */
export function getClassAdminToken(class_id) {
  return apiGet('/admin/admin_user/act_class_master', {class_id})
}

/**
 * 用户 - 申请用户token接口
 *
 * @link http://yapi.acagrid.com/project/29/interface/api/1353
 * 
 * @return Promise
 *
 * @author vince
 */
export function getUserToken(user_id) {
  return apiGet('/admin/user/act_user', {user_id})
}



// WEBPACK FOOTER //
// ./src/api/user.js